import { largestProviderByCountry } from './config';
export const supportsCountry = (country) => {
    return largestProviderByCountry.has(country.toLowerCase());
};
export const hasEnoughProviders = (quotes, country, requiredNumberOfProviders = 5) => {
    if (!supportsCountry(country)) {
        return false;
    }
    const filteredQuotes = filter(quotes, country);
    return filteredQuotes.length >= requiredNumberOfProviders;
};
export const filter = (quotes, country) => {
    if (!supportsCountry(country)) {
        return quotes;
    }
    const largestProviders = largestProviderByCountry.get(country.toLowerCase()) || [];
    return quotes.filter((quote) => largestProviders.includes(quote.provider.alias));
};
